import {
  CalendarIcon,
  ClockIcon,
  MapPinIcon,
} from "@heroicons/react/24/outline";
import React from "react";
import AddToCalendar from "~/components/add-to-calendar";
import { MindspaceEventFragment } from "~/graphql/codegen/graphql";
import { isFrontend, formatDateLong } from "~/utils";
import MindspaceEventTimes from "./mindspace-event-times";
import metrics from "~/utils/metrics";

export default function MindspaceEventDetails({
  event,
}: {
  event: MindspaceEventFragment;
}) {
  const frontend = isFrontend();
  return (
    <>
      <div className="flex items-center h-8 space-x-1">
        <CalendarIcon className="flex-none h-4 w-4 text-tertiary" />
        <div className="t-body-sm-medium text-muted-foreground hover:text-primary">
          <AddToCalendar
            events={[
              {
                id: event.id,
                name: event.name,
                startDatetime: event.startDatetime,
                endDatetime: event.endDatetime,
                description: event.eventDescription,
                joinUrl:
                  event.location?.__typename === "OnlineLocation"
                    ? event.location.joinUrl
                    : event.locationShort,
                publicUrl: event.publicUrl,
                agenda: event.agenda.map((x) => ({ title: x.title })),
              },
            ]}
            downloadFilename={event.name}
            track={() => {
              metrics.track("live_session_calendar", {
                page: "event",
                action: "add_event",
              });
            }}
            variant="ghost"
          >
            <div className="t-body-sm-medium text-muted-foreground">
              {frontend && formatDateLong(event.startDatetime)}
            </div>
          </AddToCalendar>
        </div>
      </div>
      <div className="flex items-center h-8 space-x-1">
        <ClockIcon className="flex-none h-4 w-4 text-tertiary" />
        {frontend && (
          <div className="t-body-sm-medium text-muted-foreground">
            <MindspaceEventTimes event={event} />
          </div>
        )}
      </div>
      <div className="flex items-center h-8 space-x-1">
        <MapPinIcon className="flex-none h-4 w-4 text-tertiary" />
        {event.location?.__typename === "GeoLocation" && (
          <a
            target="_blank"
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              event.location.address,
            )}`}
            className="t-body-sm-medium text-muted-foreground hover:text-primary"
          >
            {event.location.address}
          </a>
        )}
        {event.location?.__typename === "OnlineLocation" && (
          <a
            target="_blank"
            href={event.location.joinUrl}
            className="t-body-sm-medium text-muted-foreground hover:text-primary"
          >
            {event.location.text}
          </a>
        )}
      </div>
    </>
  );
}
